/**
 * 📱 КОНСТАНТЫ ПРИЛОЖЕНИЯ
 * 
 * Централизованное место для хранения названия приложения
 * и других конфигурационных значений.
 */

export const APP_NAME = 'сinemood';
export const APP_LOGO = '🎬'; // Эмодзи камеры для логотипа

